import styled from "styled-components";
// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div<{ bgColor?: string }>`
    display: flex;
    align-items: start;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing.small};
    margin: ${({ theme }) => `${theme.spacing.large} ${theme.spacing.medium}`};
    background-color: ${({ theme, bgColor }) => bgColor || theme.colors[theme.colorMode].background_Primary};
    border-radius: ${({ theme }) => theme.cornerRadius.medium};
`;

export const ImageContainer = styled.div`
    width: 16px;
    height: 16px;
    margin-top: 1px;
`;

export const TextContainer = styled(Text)(({ theme }) => {
    return {
        flex: 1,
        marginLeft: theme.spacing.xSmall,
    };
});
